<template>
  <div class="list_box">
    <div class="type">{{ item.type }}</div>
    <div class="detail">
      <ul class="left">
        <li class="item">
          <span class="item_name">被保人：</span>{{ item.name }}
        </li>
        <li class="item">
          <span class="item_name">保单号：</span>{{ item.orderId }}
        </li>
        <li class="item">
          <span class="item_name">保障期限：</span>{{ item.orderTime }}
        </li>
        <li class="item">
          <span class="item_name">保费：</span>¥{{ item.price }}
        </li>
        <li class="item">
          <span class="item_name">创建时间：</span>{{ item.createTime }}
        </li>
      </ul>
      <img class="right" :src="path[active].imgUrl" alt="" />
    </div>
    <div class="boundary"></div>
    <div class="btn_box">
      <div class="btn" v-for="(item, index) in btnForm()" :key="index">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyOrderItem",
  data() {
    return {
      btnText: ['撤保', '批改', '下载保单', '电子发票', '立即续保'],
      path: [
        { imgUrl: require('./../assets/images/pending.png') },
        { imgUrl: require('./../assets/images/guarantee.png') },
        { imgUrl: require('./../assets/images/protect.png') }
      ]
    }
  },
  props: ['item', 'active'],
  methods: {
    btnForm() {
      return this.btnText.slice(+this.active, +this.active + 3);
    }
  }
}
</script>

<style lang="less">
.list_box {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  height: 4.34rem;
  border-radius: 0.08rem;
  margin-bottom: 0.2rem;
  padding: 0.2rem 0.1rem;
  .type {
    font-size: 0.28rem;
    color: #333;
    margin-bottom: 0.1rem;
    font-weight: 700;
    margin-left: 0.2rem;
  }
  .detail {
    height: 2.4rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 0rem 0.2rem;
    .left {
      height: 2.4rem;
      width: 5.34rem;
      line-height: 0.48rem;
      font-size: 0.26rem;
      color: #666;
      .item {
        display: flex;
        flex-direction: row;
        .item_name {
          display: flex;
          width: 1.3rem;
        }
      }
    }
    .right {
      height: 1.02rem;
      width: 1.16rem;
      position: relative;
      top: 0.18rem;
    }
  }
  .boundary {
    margin-top: 0.24rem;
    width: 100%;
    height: 0.02rem;
    background-color: #ccc;
  }
  .btn_box {
    height: 1.04rem;
    width: 100%;
    padding: 0.24rem 0 0 1.86rem;
    display: flex;
    flex-direction: row;
    .btn {
      height: 0.56rem;
      width: 1.4rem;
      border: 0.01rem solid #979797;
      border-radius: 0.04rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.26rem;
      color: #666;
      margin-left: 0.2rem;
    }
  }
}
</style>